import HomePage from '../containers/HomePage/HomePage';

export default HomePage;
